<template>
  <div v-loading="vLoading"  element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!--       :wrapperClosable="detailsShow!='F'" -->
    <el-drawer
      size="680px"
      :visible.sync="drawerShow"
      :show-close="false"
      title=""
      :destroy-on-close="true"
      ref="drawer"
      custom-class="add-contact-drawer"
      :withHeader="false"
      :before-close="handleClose"

      >
      <el-button 
        size="mini" 
        class="closeBtn"
        type="primary"
        @click="handleClose"
      >收起 <i class="iconfont el-icon-download" style="transform: rotate(-90deg)" ></i> </el-button>
      <!-- 个人详情 -->
      <div class="personaldetails" v-if="detailsShow=='F'">
        <div>
          <el-row>
            <el-col :span="16">
              <div class="personalName">
                {{personalData.contactName}}
              </div>
            </el-col>
            <el-col :span="8" class="colbtn">
              <el-button v-if="personalData.isAddCustomer==1" size="mini">已添加</el-button>
               <!-- 4/7 nicole 分组暂时先不加这个功能，后期可能会加上 -->
              <!-- <el-popover
                v-else
                placement="bottom"
                width="200"
                trigger="click"
                content=""
                @hide="hide"
                >
                <div class="content">
                  <div class="add" >
                    <div class="addName" @click="addShow" v-if="!addNameShow">+创建新列表</div>
                    <div class="addFrom" v-else>
                      <el-input placeholder="输入列表名称"  v-model="input2" clear @blur="blur">
                        <template slot="append">
                          <el-button type="primary" @click="addItem">创建</el-button>
                        </template>
                      </el-input>
                    </div>
                  </div>
                  <div class="errAddName" v-if="addValShow">请输入新的列表名称</div>
                  <div v-for="(item,index) in MyGroupData" :label="item.groupName" :key="index" class="contentArr">
                    <div @click="handleCheckedCitiesChange(item,index)" class="item" :class="index==active?'active':''">
                      {{item.groupName}}
                    </div>
                  </div>
                </div>
                <div slot="reference">
                  <el-tooltip placement="left-start" effect="light">
                    <div slot="content">将联系人添加至您的收件<br/>人列表(消耗一个点数)</div>
                    <el-button type="primary" size="mini" @click="addMan" >+添加到联系人</el-button>
                  </el-tooltip>
                </div>
              </el-popover> -->
              <div v-else>
                <el-tooltip placement="bottom-end" >
                  <div slot="content">将联系人添加至您的潜在客户<br/>列表(消耗一个点数)</div>
                  <el-button v-no-more-click type="primary" size="mini" @click="addMan" >+添加到潜在客户</el-button>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
          <!-- 个人详情 -->
          <el-form>
            <el-form-item :label="'个人详情'" class="infoLabel">
              <div><hr class="hrl"></div>
            </el-form-item>
            <!-- <div class="personalCount"> -->
              <!-- 电子邮箱 -->
              <el-form-item :label="'电子邮箱:'" label-width="100px">
                <div v-if="personalData.isAddCustomer!=1"><span class="upSpan">添加到潜在客户</span>以获取信息</div>
                <div v-else>{{personalData.email||'---'}}</div>
              </el-form-item>
              <!-- 电话 -->
              <el-form-item :label="'电话:'" label-width="100px">
                <div v-if="personalData.isAddCustomer!=1"><span class="upSpan">添加到潜在客户</span>以获取信息</div>
                <div v-else-if="personalData.tel">{{personalData.codeTelStr}} {{personalData.tel}}</div>
                <div v-else>---</div>
              </el-form-item>
              <!-- Linkedln -->
              <el-form-item :label="'Linkedln:'" label-width="100px">
                <!-- <div v-if="personalData.isAddCustomer">https://www.linkedin.com/in/heidi-oas-86991b3</div> -->
                 <el-tooltip placement="bottom-start" >
                  <div slot="content">查看LinkedIn个人主页</div>
                  <div @click="linkedinLinkShow(personalData)" class="linkedin">
                    <i class="iconfont icon-yingling"></i>
                    <!-- {{personalData.linkedinLink||'---'}} -->
                  </div>
                 </el-tooltip>
              </el-form-item>
            <!-- </div> -->
          </el-form>
          <!-- 职业信息 -->
          <el-form>
            <el-form-item :label="'职业信息'" class="infoLabel">
              <div><hr class="hrl"></div>
            </el-form-item>
            <!-- <div class="employCount"> -->
              <!-- 公司 -->
              <el-form-item :label="'公司:'" label-width="80px">
                <span class="linkDiv" @click="linkCompany(personalData.companyInfoVo.id)">{{personalData.companyInfoVo.companyName||"---"}}</span>
              </el-form-item>
              <!-- 区域 -->
              <el-form-item :label="'区域:'" label-width="80px">
                <div>{{areaFmater(personalData.companyInfoVo.cityStr,personalData.companyInfoVo.stateStr,personalData.companyInfoVo.countryStr)}}</div>
              </el-form-item>
              <!-- 职务 -->
              <el-form-item :label="'职务:'" label-width="80px">
                <div>{{personalData.titleStr||"---"}}</div>
              </el-form-item>
              <!-- 行业 -->
              <el-form-item :label="'行业:'" label-width="80px">
                <div>{{personalData.companyInfoVo.industryStr||"---"}}</div>
              </el-form-item>
            <!-- </div> -->
          </el-form>
        </div>
      </div>
      <!-- 公司详情 -->
      <div class="companyDetails" v-if="detailsShow=='Y'">
        <el-row>
          <el-col :span="16">
            <div class="companyName ">
              {{companyData.companyName||'---'}}
            </div>
          </el-col>
          <el-col :span="8" class="colbtn">
            <el-button type="primary" size="mini" @click="fastSearch(companyData.companyName)">搜索更多公司联系人</el-button>
          </el-col>
        </el-row>
        <!-- 公司详情 -->
        <el-form>
          <el-form-item :label="'公司详情'" class="infoLabel">
            <div><hr class="hrl"></div>
          </el-form-item>
          <!-- 区域 -->
          <el-form-item :label="'区域:'" label-width="100px">
            <div>{{areaFmater(companyData.cityStr,companyData.stateStr,companyData.countryStr)}}</div>
          </el-form-item>
          <!-- 公司地址 -->
          <el-form-item :label="'公司地址:'" label-width="100px">
            <div>{{companyData.address||'---'}}</div>
          </el-form-item>
          <!-- 邮政编码 -->
          <el-form-item :label="'邮政编码:'" label-width="100px">
            {{companyData.zipCode||'---'}}
          </el-form-item>
          <!-- 行业 -->
          <el-form-item :label="'行业:'" label-width="100px">
            <div>{{companyData.industryStr||'---'}}</div>
          </el-form-item>
          <!-- 雇员数量 -->
          <el-form-item :label="'雇员数量:'" label-width="100px">
            <div>{{companyData.employees||'---'}}</div>
          </el-form-item>
          <!-- 企业营收 -->
          <el-form-item :label="'企业营收:'" label-width="100px">
            <div v-if="companyData.revenue">{{companyData.currencySymbol}}{{companyData.revenue|currency}}</div>
            <div v-else>---</div>
          </el-form-item>
          <!-- 网站 -->
          <el-form-item :label="'网站:'" label-width="100px">
            <span  class="linkDiv" @click="leaveCompanyData(companyData)">{{companyData.website||'---'}}</span>
          </el-form-item>
          <!-- AI匹配 -->
          <el-form-item :label="'AI匹配:'" label-width="100px" v-if="source.desEn">
            <!-- <span  class="linkDiv" @click="leaveCompanyData(companyData)">{{companyData.website||'---'}}</span> -->
            <div>
              {{source.desEn}}
            </div>
            <div v-if="source.desCn" class="desEn">
              <span>AI翻译: </span>
              <span>
                {{source.desCn}}
              </span>
            </div>
          </el-form-item>
          <!-- 数据来源 -->
          <el-form-item :label="'数据来源:'" label-width="100px" v-if="source.desEn">
            <span>AI数据挖掘</span>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog"/>
  </div>
</template>
<script>
  import {getCompId,contactGet,addToRecipient,queryMyGroup,buyerAddGroup,addToCustomer} from "@/utils/api/seamark"
  import vipBoxDialog from "@/components/common/VIPdialog"
  import { mapMutations } from 'vuex'
  export default {
    props:{
      visible:{
        type:Boolean,
        default:false
      },
      details:{
        type:String,
        default:''
      },
      companyId:{
        type:Number,
        default:''
      },
      contactId:{
        type:Number,
        default:''
      }
    },
    computed: {
      drawerShow: {
        get() {
          return this.visible;
        },
        set(v) {
          // this.$emit('changeClose', v);
        }
      },
    },
    components:{
      vipBoxDialog
    },
    data() {
      return {
        vLoading:false,
        companyNameShow:false,
        detailsShow:'',
        drawer: false,
        addNameShow:false,
        input2:'',
        active:0,
        addValShow:false,
        cities:['默认联系人组', '西门子', '西门子1', '西门子2'],
        checkedCities: ['上海'],
        lastArr:[],
        personalData:{
          companyInfoVo:{}
        },
        companyData:{},
        MyGroupData:[],
        companyIdY:'',
        contactIdF:'',
        text:'需登录您的海外领英账号进行访问,',
        url:'',
        dialogShow:false,
        addManClick:false,
        vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
        source:{
          desCn:null,
          desEn:null
        }
      };
    },
    methods: {
      ...mapMutations('linkedin', ['SET_VISIBLE', 'SET_LINKIN_URL']),
      // 快速按公司名称搜索
      fastSearch(_compName) {
        this.$emit('fastSearch', _compName);
        this.handleClose();
      },

      // 区域处理
      areaFmater(cityStr,stateStr,countryStr){
        let item=[]
        if(cityStr){
          item.push(cityStr)
        }
        if(stateStr){
          item.push(stateStr)
        }
        if(countryStr){
          item.push(countryStr)
        }
        return item.length>0?item.join():'---'
      },
      // 关闭弹框
      handleClose() {
        if(this.companyNameShow){
          this.companyNameShow=false
          this.detailsShow='F'
          // this.contactGet()
        }else{
          // done();
          this.$emit('changeClose', false);
          if(this.addManClick){
            this.$emit('addManClick')
          }
        }
      },
      linkCompany(id){
        this.companyNameShow=true
        this.companyIdY=id
        this.detailsShow='Y'
        this.getCompData()
      },
      // 添加采购商联系人分组
      async getBuyerAddGroup(){
        const res=await buyerAddGroup()
      },
      // 获取我的联系人分组
      async getQueryMyGroup(){
        const res=await queryMyGroup()
        this.MyGroupData=res.rspListData.list
      },
      // 获取公司数据
      async getCompData(){
        const res=await getCompId(this.companyIdY)
        if(res.rspResult.bizCode==200){
          this.companyData=res.data
        }else{
          this.$message.error(res.rspResult.message);
        }
      },
      // 获取联系人详情数据
      async contactGet(){
        const res=await contactGet(this.contactIdF)
        if(res.rspResult.bizCode==200){
          this.personalData=res.data
        }else{
          this.$message.error(res.rspResult.message);
        }
        console.log(res)
      },
      // 弹框隐藏需要清空里里面的组件
      hide(){
        this.addNameShow=false
      },
      // 添加联系人新列表
      addItem(){
        if(this.input2==''){
        this.addValShow=true
        }else{
          this.cities.push(this.input2)
          this.input2=''
        }
      },
      // 创建新列表校验
      blur(){
        if(this.input2==''){
        //  this.addValShow=true
        }else{
        this.addValShow=false
        }
      },
      // 添加联系人创建新列表
      addShow(){
        this.addNameShow=!this.addNameShow
      },
      // 添加联系人
      handleCheckedCitiesChange(value,index){
        console.log(index)
        this.active=index
        // 联系人添加成功
        this.$message({
          message: '联系人添加成功',
          type: 'success'
        });
      },
      /**
       * //个人详情中的添加联系人按钮事件
       * // 添加联系人按钮事件, 未购买营销产品包客户，点击“添加联系人”，
       * // 弹窗显示升级提示。点击“立即升级”跳转至产品购买页。产品购买页新开页打开
      **/
      async addMan(){
        //点数不够弹框或者未买点数弹框
        // this.getQueryMyGroup() 
        let itemArr=[]
        itemArr.push(this.personalData.id)
        let prams={
          "contactIds": itemArr
        }
        this.vLoading=true
        const res =await addToRecipient(prams)
        console.log(res)
        if(res.rspResult.bizCode==200){
          // successNumber
          if(res.data.successNumber>0){
            this.$message.success(`已添加${res.data.successNumber}个潜在客户`)
          }else if(res.data.successNumber==-9999){
            this.$message.warning(`系统繁忙，请稍后再试`)
          }else{
            this.$message.success(`已添加潜在客户`)
          }
          this.vLoading=false
          // 刷新页面
          this.contactGet()
          this.addManClick=true
        }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
          this.vLoading=false
          this.vipCode=res.rspResult.bizCode
          this.$refs.vipBoxDialog.centerDialogVisible=true
        }else{
          this.vLoading=false
          this.$message.error(res.rspResult.message)
        }

      },
      // 公司详情中，把采购商公司添加为潜在客户
      async addCustomer(){
      console.log('添加潜在客户')
      let prams ={
        compId:this.companyId
      }
      const res =await addToCustomer(prams)
      console.log(res)
      },
      // 跳转linkin
      linkedinLinkShow() {
        this.SET_VISIBLE(true)
        this.SET_LINKIN_URL(this.personalData.linkedinLink)
      },
      // 公司网站
      leaveCompanyData(companyData){
        // this.dialogShow=true
        // this.text=''
        // this.url=this.companyData.website
        let url=this.companyData.website
        if (!/^(http|https):\/\//i.test(url)) {
          url = '//' + url
        }
        window.open(url,'_blank')
      },
      // 关键词添加
      sourceData(val){
        this.source=val
      }
    },
    mounted(){
      this.detailsShow=this.details
      if(this.contactId==-1){
        this.contactIdF=''
      }
      if(this.companyId==-1){
        this.companyIdY=''
      }
      if(this.details=='F'){
        this.contactIdF=this.contactId
        this.contactGet()
      }
      if(this.details=='Y'){
        this.companyIdY=this.companyId
        this.getCompData()
      }
      // this.getQueryMyGroup()
    },

  };
</script>

<style lang="scss" scoped>
.personaldetails{
  margin-top:28px;
  padding-right: 20px;
  padding-left: 20px;
  .personalName{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181A;
    margin-bottom: 24px;
  }
  .colbtn{
    text-align: right;
  }
  .personalCount{
    margin-left: 16px;
  }
  .employCount{
    margin-left: 16px;
  }
}
.companyDetails{
  margin-top:28px;
  padding-right: 20px;
  padding-left: 20px;
  .companyName{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181A;
    margin-bottom: 24px;
  }
  .colbtn{
    text-align: right;
  }
}
::v-deep .el-form{
  .el-form-item{
    .el-form-item__label{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4F5D78;
    }
  }
  .infoLabel{
    .el-form-item__label{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181A;
    }
  }
}

.hrl{
  background-color: #E5E8ED;
  height: 1px;
  border: none;
  margin-top: 15px;
}
.detailsname{
  // text-align: center;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #16181A;
}
.add{
  border-bottom: 1px solid  #EDF0F4;
  margin-bottom: 6px;
  padding-bottom: 16px;
  .addName{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #066EB7;
    padding-left: 12px;
    cursor: pointer;
  }
}
.contentArr{
  height: 40px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;
  line-height: 40px;
  .item{
    padding-left: 12px;
    cursor: pointer;
  }
  .item:hover{
    background: #F5F7FA;
  }
}
.active{
  background: #F5F7FA;
}
.errAddName{
  color: red;
}
.linkDiv{
  color: #066EB7;
  cursor: pointer;
}
.upSpan{
  color: #16181aff;
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
}
.linkedin{
  cursor: pointer;
  width: 30px;
  .iconfont{
    color: #066EB7;
  }
}
.closeBtn{
  position: fixed;
  right: 672px;
  top: 50px;
  box-shadow: 2px 0 4px 0 rgba(49,140,237,0.3);
  border-radius: 2px;
  background: #318CED;
  border-color: #318CED;
  .iconfont{
    margin-left: 4px;
    font-size: 12px;
  }
}
.closeBtn:hover{
  background: #318CED !important;
  border-color: #318CED !important;
  color: #ffffff !important;
}
.desEn{
  background: #F3F5F8;
  padding: 8px;
}
</style>
